// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

import Popover from 'bootstrap/js/dist/popover';

document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
  new Popover(el, {
    container: 'body',
  });
});

import './modules/admin';
import './modules/bubbles';
import './modules/text-smooth';
import './modules/devise.ts';
import './modules/sliders';
import './modules/top-banner';
import './modules/popup-newsletter';
import './modules/header';
import './modules/home-hero';
import './modules/aos';
import './modules/more-faq';
import './modules/magnetic';
import './modules/simulator';
import './modules/range-slider';
import './modules/video-yt';
import './modules/jobs-section';
import './modules/form-hidden';
import './modules/contact-form';
import './modules/demo-form';
